import jsPDF from 'jspdf';

const LOGO_TEXT = "TIA KAROL SPORTS";
const COMPANY_PHONE = "5618596830";

export function generatePaymentReceipt(payment, options = {}) {
  const { forAdmin = false } = options;
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  
  // Colors
  const orange = [232, 93, 4];
  const dark = [26, 26, 26];
  const gray = [115, 112, 106];
  const lightBg = [245, 242, 235];
  const green = [45, 106, 79];

  // Header background
  doc.setFillColor(...orange);
  doc.rect(0, 0, pageWidth, 45, 'F');
  
  // Logo text
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(22);
  doc.setFont('helvetica', 'bold');
  doc.text(LOGO_TEXT, 20, 25);
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('Escola de Futevôlei', 20, 35);

  // Receipt title
  doc.setTextColor(...dark);
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text('COMPROVANTE DE PAGAMENTO', 20, 65);

  // Divider
  doc.setDrawColor(...orange);
  doc.setLineWidth(1);
  doc.line(20, 70, pageWidth - 20, 70);

  // Receipt details
  let y = 85;
  const leftCol = 20;
  const rightCol = 90;

  const addField = (label, value, yPos) => {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(...gray);
    doc.text(label, leftCol, yPos);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.setTextColor(...dark);
    doc.text(String(value || '-'), rightCol, yPos);
    return yPos + 12;
  };

  y = addField('Aluno:', payment.student_name || '-', y);
  y = addField('Mês Referência:', payment.reference_month || '-', y);
  y = addField('Data Pagamento:', payment.payment_date || '-', y);
  y = addField('Método:', payment.payment_method || '-', y);
  y = addField('Plano:', payment.plan ? `${payment.plan}/semana` : '-', y);
  
  if (payment.notes) {
    y = addField('Observações:', payment.notes, y);
  }

  // Amount box
  y += 10;
  doc.setFillColor(...lightBg);
  doc.roundedRect(20, y, pageWidth - 40, 30, 3, 3, 'F');
  
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...gray);
  doc.text('VALOR PAGO', 30, y + 13);
  
  doc.setFontSize(22);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...green);
  doc.text(`$${(payment.amount || 0).toFixed(2)}`, 30, y + 26);

  // Status
  const status = (payment.status || 'pendente').toUpperCase();
  const statusColor = status === 'PAGO' ? green : [155, 34, 38];
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...statusColor);
  doc.text(status, pageWidth - 30, y + 20, { align: 'right' });

  // Footer
  y += 50;
  doc.setDrawColor(230, 226, 216);
  doc.setLineWidth(0.5);
  doc.line(20, y, pageWidth - 20, y);
  
  y += 12;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...gray);
  
  const now = new Date();
  const timestamp = now.toLocaleDateString('pt-BR') + ' ' + now.toLocaleTimeString('pt-BR');
  
  doc.text(`Comprovante gerado em: ${timestamp}`, 20, y);
  doc.text(`ID: ${payment.id || '-'}`, 20, y + 8);
  doc.text(`Tia Karol Sports | Tel: ${COMPANY_PHONE}`, 20, y + 16);
  
  if (forAdmin) {
    doc.text('** CÓPIA DO ADMINISTRADOR **', pageWidth - 20, y + 16, { align: 'right' });
  }

  // Generate filename
  const studentName = (payment.student_name || 'aluno').replace(/\s+/g, '_');
  const month = payment.reference_month || 'sem_mes';
  const prefix = forAdmin ? 'admin_' : '';
  const filename = `${prefix}comprovante_${studentName}_${month}.pdf`;

  doc.save(filename);
  return filename;
}

export function generateLeagueReceipt(registration) {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  
  const orange = [232, 93, 4];
  const dark = [26, 26, 26];
  const gray = [115, 112, 106];
  const lightBg = [245, 242, 235];
  const green = [45, 106, 79];

  doc.setFillColor(...orange);
  doc.rect(0, 0, pageWidth, 45, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(22);
  doc.setFont('helvetica', 'bold');
  doc.text(LOGO_TEXT, 20, 25);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('TK League / Rei e Rainha', 20, 35);

  doc.setTextColor(...dark);
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text('COMPROVANTE DE INSCRIÇÃO', 20, 65);

  doc.setDrawColor(...orange);
  doc.setLineWidth(1);
  doc.line(20, 70, pageWidth - 20, 70);

  let y = 85;
  const addField = (label, value, yPos) => {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(...gray);
    doc.text(label, 20, yPos);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.setTextColor(...dark);
    doc.text(String(value || '-'), 90, yPos);
    return yPos + 12;
  };

  y = addField('Nome:', registration.name, y);
  y = addField('Email:', registration.email, y);
  y = addField('Telefone:', registration.phone, y);
  
  const catLabels = { misto: 'Misto', open: 'Open', feminino: 'Feminino', rei_rainha: 'Rei e Rainha' };
  const cats = (registration.categories || []).map(c => catLabels[c] || c).join(', ');
  y = addField('Categorias:', cats, y);
  y = addField('Status:', (registration.status || '').toUpperCase(), y);
  y = addField('Pagamento:', (registration.payment_status || '').toUpperCase(), y);

  y += 10;
  doc.setFillColor(...lightBg);
  doc.roundedRect(20, y, pageWidth - 40, 30, 3, 3, 'F');
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...gray);
  doc.text('VALOR', 30, y + 13);
  doc.setFontSize(22);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...green);
  doc.text('$30.00', 30, y + 26);

  y += 50;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...gray);
  const now = new Date();
  doc.text(`Gerado em: ${now.toLocaleDateString('pt-BR')} ${now.toLocaleTimeString('pt-BR')}`, 20, y);
  doc.text(`Tia Karol Sports | Tel: ${COMPANY_PHONE}`, 20, y + 8);

  const filename = `comprovante_liga_${(registration.name || '').replace(/\s+/g, '_')}.pdf`;
  doc.save(filename);
  return filename;
}
